import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import PrescriptionNew from '@screens/vision/source/sections/PrescriptionNew'
import PrescriptionManual from '@screens/vision/source/sections/PrescriptionManual'

export default function PrescriptionCreate() {
  const { t } = useTranslation(['vision'])
  const text = 'vision:prescription.create'

  return (
    <Page stage="vision" validateStaff>
      <Header
        title={t(`${text}.header.title`)}
        desc={t(`${text}.header.desc`)}
      />
      <View className="gap-8 px-8">
        <PrescriptionNew />
        <PrescriptionManual />
      </View>
    </Page>
  )
}
